export const categoriesMainData = [
    {
        id: 1,
        name: 'Current Events & Politics'
    },
    {
        id: 2,
        name: 'Beauty & Health'
    },
    {
        id: 3,
        name: 'Lifestyle & Culture'
    },
    {
        id: 4,
        name: 'Aspiration'
    },
    {
        id: 5,
        name: 'Money/ Finances/ Education'
    },
    {
        id: 6,
        name: 'Food & Bevarage'
    },
    {
        id: 7,
        name: 'Love & Relationship'
    },
    {
        id: 8,
        name: 'Fashion'
    },
    {
        id: 9,
        name: 'Media Entertinment/ Technology'
    }

]